// extracted by mini-css-extract-plugin
module.exports = {"EventPhoto":"EventGallery_EventPhoto__2gyiZ","GalleryTitle":"EventGallery_GalleryTitle__1GZmC"};